import React from "react";
import Icon from "./Icon.jsx";
import { styles } from "./ImageBulletPoints.styles";

const shouldCenterPoint = point =>
  (point.title && !point.text) || (!point.title && point.text);

const ImageBulletPoints = props => (
  <div className={`image-bullet-points ${styles.imageBulletPoints}`}>
    {props.points.map((point, index) => (
      <div
        key={index}
        className={`
        image-bullet-points__point
        image-bullet-points__point--${props.size || "large"}
        image-bullet-points__point--${
          shouldCenterPoint(point) ? "center" : "start"
        }
      ${styles.point({ size: props.size || "large" })} ${styles.point({
          position: shouldCenterPoint(point) ? "center" : "start"
        })}`}
      >
        {point.image && (
          <img
            alt={point.text}
            src={point.image}
            className={`image-bullet-points__point-image ${styles.pointImage}`}
          />
        )}
        {point.icon && (
          <span
            className={`image-bullet-points__point-icon ${styles.pointIcon}`}
          >
            <Icon icon={point.icon} height={25} />
          </span>
        )}
        <div
          className={`image-bullet-points__point-text-wrap ${styles.pointTextWrap}`}
        >
          {point.title && (
            <div
              className={`image-bullet-points__point-title ${styles.pointTitle}`}
            >
              {point.title}
            </div>
          )}
          {point.text && (
            <div
              className={`image-bullet-points__point-text ${styles.pointText}`}
            >
              {point.text}
            </div>
          )}
        </div>
      </div>
    ))}
  </div>
);

export default ImageBulletPoints;
